import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {BaseStyle} from "../../../../infrastructure/models/base-style";
import classNames from "classnames";
import styles from './card-title.module.scss';

export class CardTitleComponentProps extends BaseProps {
  title: String;
  children: React.Component;
  titleStyle: BaseStyle;
}

export const CardTitle = ({className, children, title, TitleTag}: CardTitleComponentProps) => {
  return (
    <TitleTag className={classNames(styles.card_title_container, className)}>
      {children || title}
    </TitleTag>
  )
}
